import React, { useState, useRef, useEffect } from 'react';

import ImageLoader from '../../../../molecules/Image';
import { TestimonialsData } from '../constant';

function Desktop() {
  const ref = useRef(null);
  const [state, setState] = useState(1);
  const [containerWidth, setContainerWidth] = useState(null);

  useEffect(() => {
    const { width } = ref.current.getBoundingClientRect();

    setContainerWidth(width);
  }, [state]);

  return (
    <div className='p-t-b-60 relative'>
      <img className='trusted_companies__quote' height='55px' src='/images/homepage/trustedCompanies/trustedComapaniesIcon.png' width='55px' />
      <div className='offset-md-1 col-md-10'>
        <div className='row'>
          <h2 className='bold relative p-b-50 col-md-4 font-32px'>Trusted by the world’s largest and fastest growing companies</h2>
          <div className='relative testimonials_container br-24 bg-white col-md-7 testimonials-shadow' ref={ref}>
            {TestimonialsData.map((testimonial) => {
              if (containerWidth) {
                return (
                  <div className='py-5' key={testimonial.name}>
                    <div className='testimonials_testimonial' style={{ width: `${containerWidth}px`, transform: `translateX(${-(state - 1) * containerWidth}px)` }}>
                      <div className='row mx-0'>
                        <div className='col-md-2'>
                          <ImageLoader alt={testimonial.icon} className='rounded-circle' height={64} objectFit='contain' src={`/images/${testimonial.icon}.png`} width={64} />
                        </div>
                        <div className='col-md-10 pl-md-0'>
                          <div className='font-18px black bold my-1'>{testimonial.name}</div>
                          <div className='font-12px gray mb-2 my-1'>{testimonial.title}</div>
                          <div className='mb-4 relative'>
                            {[1, 2, 3, 4, 5].map((rate) => (
                              <span className='mx-1' key={rate}>
                                <ImageLoader alt='star icon' height={24} src='/images/onboarding-icons/selected-star.svg' width={24} />
                              </span>
                            ))}
                          </div>
                        </div>
                        <div className='offset-md-2 col-md-10 pl-md-0 font-14px gray pr-4'>{testimonial.description}</div>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </div>
          <div className='center-x-y offset-md-4 col-7 mt-4'>
            {Array(TestimonialsData.length)
              .fill()
              .map((_, i) => i + 1)
              .map((num) => (
                <div className={`rounded-circle pointer center-x-y ${state === num ? 'testimonials_active' : 'testimonials_inactive'}`} key={num} onClick={() => setState(num)}>
                  <div />
                </div>
              ))}
          </div>
        </div>
      </div>
      <style jsx>{`
        .trusted_companies__quote {
          position: absolute;
          right: 20%;
          top: 30px;
          z-index: 1;
        }
        .testimonials-shadow {
          box-shadow: 0px 2px 187px 0px #0000001a;
        }
      `}</style>
    </div>
  );
}

export default Desktop;
